export default "__VITE_ASSET__uNY284jp__"